import Vue from "vue";
import Router from "vue-router";
import Login from "@/components/Login";
import ForgotPassword from "@/components/ForgotPassword";
import ResetPassword from "@/components/ResetPassword";
import SingleUpload from "@/components/SingleUpload";
import BatchUpload from "@/components/BatchUpload";
import About from "@/components/About";
import MyAccount from "@/components/MyAccount";
// BB 
import Table from "@/components/Table";

Vue.use(Router)

export default new Router({
  mode: "history",

  routes: [
    {
      path: "/",
      redirect: "/upload",
    },
    {
      path: "/login",
      component: Login,
    },
    {
      path: "/forgot",
      component: ForgotPassword,
    },
    {
      path: "/reset",
      component: ResetPassword,
    },
    {
      path: "/upload",
      component: SingleUpload,
    },
    {
      path: "/batch",
      component: Table,
    },
    {
      path: "/about",
      component: About,
    },
    {
      path: "/myaccount",
      component: MyAccount,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js